'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useState, useEffect } from 'react';
import { CookieInvalidError } from '@dynamic-labs/utils';
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../constants/colors.js';
import '../../constants/values.js';
import '../../../shared/utils/classes/storage/localStorage.js';
import '../../../shared/utils/classes/storage/sessionStorage.js';
import '../../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import { getAuthToken } from '../../functions/getAuthToken/getAuthToken.js';
import 'react-international-phone';
import '../../../config/ApiEndpoint.js';
import { getUser } from '../../../store/actions/userActions/userActions.js';
import '../../../locale/locale.js';
import { getAuthenticatedUser } from '../../../data/api/user/user.js';
import { isCookieEnabled } from '../../functions/isCookieEnabled/isCookieEnabled.js';
import '@dynamic-labs/store';
import { getEnvironment, setEnvironment } from '../../../store/actions/storeActions/storeActions.js';
import '../../../events/dynamicEvents.js';
import '../../../context/DynamicContext/DynamicContext.js';
import '../../../context/CaptchaContext/CaptchaContext.js';
import '../../../context/ErrorContext/ErrorContext.js';
import '../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../context/AccountExistsContext/AccountExistsContext.js';
import '../../../context/UserWalletsContext/UserWalletsContext.js';
import '../../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../../context/WalletContext/WalletContext.js';
import '../../../context/ThemeContext/ThemeContext.js';
import '../useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import '@dynamic-labs/types';
import '../../../context/LoadingContext/LoadingContext.js';
import 'yup';
import '../../../context/MockContext/MockContext.js';
import '../../../views/CollectUserDataView/useFields.js';
import '../../../context/FieldsStateContext/FieldsStateContext.js';
import '../../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import 'react-i18next';
import '../../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../../components/Alert/Alert.js';
import '../../../components/ShadowDOM/ShadowDOM.js';
import '../../../components/IconButton/IconButton.js';
import '../../../components/InlineWidget/InlineWidget.js';
import '../../../components/Input/Input.js';
import '../../../components/IsBrowser/IsBrowser.js';
import '../../../components/MenuList/Dropdown/Dropdown.js';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../components/OverlayCard/OverlayCardTarget/OverlayCardTarget.js';
import '../../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../../components/Popper/Popper/Popper.js';
import '../../../components/Popper/PopperContext/PopperContext.js';
import 'react-focus-lock';
import 'qrcode';
import 'formik';
import '../../../views/WalletList/WalletList.js';
import '../../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../../context/FooterAnimationContext/index.js';
import '../../../context/WalletGroupContext/WalletGroupContext.js';
import '../../../context/MfaSettingsContext/MfaSettingsContext.js';
import '../../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../../context/PasskeyContext/PasskeyContext.js';
import '../../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import '../../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../../views/TransactionConfirmationView/helpers/transactionErrorMessage.js';
import '../../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';

const useValidateSession = ({ environmentId, handleLogOut }) => {
    const [hasLoggedOut, setHasLoggedOut] = useState(false);
    const logout = (reason, params) => __awaiter(void 0, void 0, void 0, function* () {
        setHasLoggedOut(true);
        logger.debug(`Logging out - Reason: ${reason}`, Object.assign({}, params));
        yield handleLogOut();
    });
    const handleUserDataOutOfSync = () => __awaiter(void 0, void 0, void 0, function* () {
        const cookieEnabled = isCookieEnabled();
        const authToken = getAuthToken();
        const user = getUser();
        if (authToken || !user) {
            return;
        }
        if (user && !authToken && cookieEnabled) {
            try {
                yield getAuthenticatedUser({ environmentId });
            }
            catch (e) {
                if (e instanceof CookieInvalidError) {
                    yield logout('user auth cookie invalid', {
                        authToken,
                        user,
                    });
                }
            }
            return;
        }
        yield logout('user data out of sync', {
            authToken,
            user,
        });
    });
    const handleStoreAndEnvironemntMismatch = () => __awaiter(void 0, void 0, void 0, function* () {
        const storeEnvId = getEnvironment();
        if (!storeEnvId || environmentId === storeEnvId) {
            return;
        }
        yield logout('store and environment are out of sync', {
            currentEnvId: environmentId,
            storedEnvId: storeEnvId,
        });
        setEnvironment(environmentId);
    });
    useEffect(() => {
        if (!hasLoggedOut) {
            handleStoreAndEnvironemntMismatch();
            handleUserDataOutOfSync();
        }
    }, [hasLoggedOut]);
    return { setHasLoggedOut };
};

export { useValidateSession };
